<div fxLayout="column" fxLayoutAlign="start center">
  <div id="button-bar" fxLayout="row" fxLayoutAlign="start center" fxFlexFill class="button-bar-keyboard">
    <div fxFlex="grow">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" class="user-daily-stats" *ngIf="hasDailyStats">
        <div>
          <button type="button" mat-icon-button (click)="openTodayStats()"
            [matTooltip]="'phone_header.today_stats'|translate" data-ci="today-stats">
            <mat-icon>assessment</mat-icon>
          </button>
        </div>
        <ng-container *ngIf="userDailyStats">
          <div>
            <span>{{'agent_panel.daily.qos'|translate}}: <b>{{userDailyStats.qos}}%</b></span>
          </div>
          <div>
            <span>{{'agent_panel.daily.today_call_count'|translate}}: <b>{{todayPerformance?.outbound_call_count +
                todayPerformance?.inbound_call_answered}}</b></span>
          </div>
        </ng-container>
      </div>
    </div>
    <div fxFlex="initial" fxLayout="row" fxLayoutAlign="end start" fxLayoutGap.xs="5px" fxLayoutGap="10px">
      <div fxFlex fxLayoutAlign="end none">
        <div *ngIf="inboundOnSecondaryNumber" fxFlex fxLayoutAlign="end none">
          <div class="reception-div" (click)="openChangeReceiveCallNumberDialog()"
            matTooltip="{{'call_active.hint.call_reception'|translate}}">
            <div class="wrapper-icon-device" data-ci="laptop">
              <mat-icon class="reception-icon" [ngClass]="{'reception-off' : connection_status.phone_mode == 1}">
                laptop
              </mat-icon>
            </div>
            <div class="wrapper-icon-device" data-ci="smartphone">
              <mat-icon class="reception-icon" [ngClass]="{'reception-off' : connection_status.phone_mode == 0}">
                smartphone
              </mat-icon>
            </div>
          </div>
        </div>

        <div class="border-left">
          <button *ngIf="!connection_status.is_paused;else UnpauseBlock" id="pause" mat-icon-button
            class="action-button" (click)="pause()" matTooltip="{{'call_active.hint.pause_agent'|translate}}">
            <mat-icon class="icon-black">pause</mat-icon>
          </button>
          <ng-template #UnpauseBlock>
            <button id="unpause" mat-icon-button class="action-button" (click)="unpause()"
              matTooltip="{{'call_active.hint.unpause_agent'|translate}}">
              <mat-icon class="icon-black">play_arrow</mat-icon>
            </button>
          </ng-template>
        </div>
        <!-- <div class="border-left">
          <button id="ring" mat-icon-button class="action-button" (click)="changeSilentMode()">
            <mat-icon *ngIf="phoneConfig?.silent_mode">
              <img src="assets/images/ring-off.png">
            </mat-icon>
            <mat-icon *ngIf="!phoneConfig?.silent_mode">
              <img src="assets/images/ring-on.png">
            </mat-icon>
          </button>
          <button id="ring" class="action-button" (click)="changeSilentMode()">
            <img src="assets/images/ring-on.png" class="icon-ring">
          </button>
          <button id="ring" class="action-button" (click)="changeSilentMode()">
              <img src="assets/images/ring-on.png" class="icon-ring">
            </button>
          <button mat-icon-button class="btn-volumn" (click)="changeVolumn()"
            matTooltip="{{'call_active.hint.change_volumn'|translate}}">
            <mat-icon>volume_up</mat-icon>
          </button>
        </div> -->
      </div>
    </div>
  </div>

  <div fxLayout="column" fxLayoutAlign="center center" id="top-container" class="container ">
    <div class="calling-number-container full-width" fxLayout="row">
      <div *ngIf="directionSelectable" fxFlex="80px">
        <mat-form-field class="state-field mat-input-xs full-width" appearance="none">
          <mat-label>{{ 'agent_panel.content.available_for'|translate }}</mat-label>
          <mat-select [(ngModel)]="inOutState">
            <mat-option *ngFor="let state of inOutStateList" [value]="state">
              {{ ('agent_panel.content.inout_state_' + state) | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="directionSelectable" class="border" fxFlex="2px"></div>

      <div *ngIf="allowSelectQueueForOutbound" fxFlex>
        <mat-form-field class="number-field mat-input-xs full-width" appearance="none">
          <mat-label>{{ 'stats.filter.queue'|translate }}</mat-label>
          <queue-select-form-input [ngModel]="callQueueForCalling" [allowEmpty]="true" [agent]="agent"
            (selectionChange)="changeCallingQueue($event)">
          </queue-select-form-input>
        </mat-form-field>
      </div>

      <div fxFlex>
        <mat-form-field class="number-field mat-input-xs full-width" appearance="none">
          <mat-label>{{ 'agent_panel.content.my_number'|translate }}</mat-label>
          <calling-number-form-input [ngModel]="phoneCallingNumber" (selectionChange)="changeCallingNumber($event)">
          </calling-number-form-input>
        </mat-form-field>
      </div>
    </div>
  </div>

</div>
